import { FC } from "react";
import cn from "classnames";
import { useNavigate } from "react-router";

import { formatPriceDisplay } from "capitalrx-utilities";

import styles from "./PharmacyResultsCard.module.scss";
import { Card, Icon, useSetQuery } from "../..";
import { PharmacyResultsCardProps } from "./PharmacyResultsCard.props";

export const PharmacyResultsCard: FC<PharmacyResultsCardProps> = ({
  price,
  priceUnavailableText = "Price Unavailable",
  className,
  priceButtonClassname,
  children,
  linkTo,
  isMaxUsualAndCustomaryCharge,
  providerId,
  distance,
}: PharmacyResultsCardProps) => {
  // Don't display price if Max U&C is charged
  if (isMaxUsualAndCustomaryCharge) {
    price = NaN;
  }

  const resultCardContainerClasses = cn(styles["ResultCardContainer"], className);
  const priceResultsClasses = cn({ [styles["Price"]]: price }, priceButtonClassname, {
    [styles["PriceUnavailable"]]: isNaN(Number(price)),
  });

  const navigate = useNavigate();
  const [_, setQuery] = useSetQuery();

  let showPrice = "";
  if (price) {
    showPrice = formatPriceDisplay(Number(price));
  }

  const pharmacyDetailsHandler = () => {
    navigate({
      pathname: linkTo,
      search: setQuery({ providerId: `${providerId}`, price: `${price}`, distance: `${distance}` }),
    });
  };

  return (
    <button onClick={pharmacyDetailsHandler} className={styles.ResultCardWrapper}>
      <Card className={resultCardContainerClasses}>
        {children}
        <div className={styles.PriceContainer}>
          <span className={priceResultsClasses}>{price ? showPrice : priceUnavailableText}</span>
          <Icon name="carat-right" color="turquoise" className={styles.Carat} />
        </div>
      </Card>
    </button>
  );
};
